<template>
  <div id="spinner" class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
    <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue'

export default defineComponent({
  name: 'SpinnerView',
  setup () {
    onMounted(() => {
      setTimeout(() => {
        const spinner = document.getElementById('spinner')
        if (spinner) {
          spinner.classList.remove('show')
        }
      }, 1)
    })
  }
})
</script>
